<template>
  <div :class="classList">
    <p class="c-accordion-item__title" @click="toggleOpen" @keyup.enter="toggleOpen" tabindex="0">{{title}}</p>
    <div class="c-accordion-item__content" v-if="isOpen" v-html="content"></div>
  </div>
</template>

<script>
export default {
  name: "accordion-item",

  props: {
    title: String,
    content: String
  },

  data() {
    return {
      isOpen: false
    };
  },

  computed: {
    classList() {
      return {
        "c-accordion-item": true,
        "is-open": this.isOpen,
        "is-closed": !this.isOpen
      };
    }
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen
    }
  },
};
</script>

<style lang="scss">
.c-accordion-item {
  background: $colour-nhs-white;
  box-shadow: none;
  transition: box-shadow 0.4s ease;
  border-top: 1px solid $colour-nhs-pale-grey;
  margin: 0;

  &__title,
  &__content {
    margin: 0;
  }

  &__title {
    padding: 1em 2em 1em 1em;
    cursor: pointer;
    position: relative;

    &:after {
      position: absolute;
      right: 15px;
      top: 50%;
      content: "";
      border: 5px solid transparent;
      border-top-color: $colour-nhs-blue;
      transform: rotate(-90deg);
      transition: all ease-in-out 0.2s;
      transform-origin: top center;
    }
  }

  &__content {
    line-height: 1.444;
    font-size: 14px;
    padding: 0 1em 1em 1em;

    * {
      color: $colour-nhs-dark-grey !important;
    }

    a {
      color: $colour-nhs-core-blue !important;
      text-decoration: underline;
    }
  }

  &.is-closed:hover,
  &.is-open {
    position: relative;
    z-index: 5;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.11);
    border-color: transparent;
  }

  &.is-open &__title {
    color: $colour-nhs-blue;
    &:after {
      transform: rotate(0deg);
      transform: translateY(-1px);
    }
  }
}
</style>
